goog.provide('el8.appshared.dialog.discreteLabFields');

goog.require('el8.appchart.dialog.createLabResultTest');
goog.require('el8.service.urls');
goog.require('el8.template.appshared.dialog.addDiscreteLabValues');
goog.require('el8.util.consts');

el8.appshared.dialog.discreteLabFields = (function() {

    var module = {};

    var form = null;
    var container = null;
    var labValuesDict = null;
    var adjustHeightFn = null;

    /**
     * Get the Field Spec for a Form built for discrete labs. Note, you MUST
     * call module.init at some point, or this function will break, because the object
     * 'form' will not have any content
     */
    module.getFields = function(isFilerForm) {

        //mindreaders in the Filer only should right-align to the text field
        var panelLeftOffset = (isFilerForm) ? -120 : 0;
        var testLeftOffset = (isFilerForm) ? -150 : 0;

        return [
            {
                name: 'vendorId',
                selector: ':input[name="vendorId"]',
                validate: {
                    required: true
                }
            },
            {
                name: 'panelName',
                selector: ':input[name="panelName"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'panel name (e.g., lipid panel)',
                validate: {
                    required: true
                },
                mindreaderOpts: {
                    url: function() {
                        return el8.service.urls.get('labTestPanels', [form.getVal('vendorId')]);
                    },
                    containerHeight: 200,
                    containerLeftOffset: panelLeftOffset,
                    formatResult: function(item) { return item.name; },
                    formatSelected: function(item) { return item.name; },
                    actions: [
                        {
                            name: 'Create a new lab panel with this name...',
                            actionFn: function(val) { promptForPanel(val); }
                        }
                    ]
                },
                newMindreader: true
            },
            {
                name: 'testName',
                selector: ':input[name="testName"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'test...',
                validate: {
                    required: true
                },
                mindreaderOpts: {
                    url: function() {
                        var vendorId = form.getVal('vendorId');
                        var panelItem = form.getMindreaderItem('panelName');
                        var categoryId;
                        if (panelItem) { categoryId = panelItem.id; }

                        return el8.service.urls.get('labTests', [vendorId, categoryId]);
                    },
                    actions: [{
                        name: 'Create a new test with this name...',
                        actionFn: function(val) { promptForTest(val); }
                    }],
                    containerLeftOffset: testLeftOffset,
                    containerWidth: 300,
                    formatResult: function(item) { return item.name; },
                    formatSelected: function(item) { return item.name; },
                    selectFn: function(event, item) {
                        if (item.isManual) { return; }
                        var autoFill = function(fieldName, val) {
                            if (val) { form.setVal(fieldName, val); }
                        };
                        $.el8_ajax({
                            url: el8.service.urls.get('labTestPreferences', [item.id]),
                            type: 'GET',
                            success: function(data) {
                                if (!data) { return; }
                                autoFill('refMin', data.reference_min);
                                autoFill('refMax', data.reference_max);
                                autoFill('units', data.units);
                            }
                        });
                    }
                },
                newMindreader: true
                // maxLength: 120,
            },
            {
                name: 'value',
                selector: ':input[name="testValue"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'val...',
                validate: {
                    required: true
                }
            },
            {
                name: 'refMin',
                selector: ':input[name="refMin"]',
                infoText: 'min...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                validate: {
                    required: true
                }
            },
            {
                name: 'refMax',
                selector: ':input[name="refMax"]',
                infoText: 'max...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                validate: {
                    required: true
                }
            },
            {
                name: 'units',
                selector: ':input[name="units"]',
                infoText: 'units...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                mindreaderOpts: {
                    url: function() {
                        return el8.service.urls.get('labTestUnits');
                    },
                    formatResult: function(item) { return item.units; },
                    formatSelected: function(item) { return item.units; }
                },
                validate: {
                    required: true
                }
            }
        ];
    };

    /**
     * Initialize a discrete labs form (setup listeners and shared variables)
     */
    module.init = function(spec) {
        container = spec.container;
        form = spec.form;
        if (!(container && form)) { return; }
        adjustHeightFn = spec.adjustHeightFn || null; //the only optional field here

        labValuesDict = {};
        bindListeners();
    };

    // same as fax inbox, getting a list of panels based on current patient from server
    module.populatePanelForPatient = function() {
        var that = this;
        var patientId = el8.ptdata.currPatient.getId();
        $.el8_ajax({
            type: 'GET',
            async: false,
            url: '/patient/'+patientId+'/reports/panels/',
            success: function(data) {
                if (data && data['panels']) {
                    that.updatePanelLabValues(data['panels']);
                }
                else {
                    that.updatePanelLabValues([]);
                }
            },
            error_override: function() {
                that.updatePanelLabValues([]);
            }
        });
    }

    module.populateGrids = function(vendorId, grids) {
        for (var i=0; i < grids.length; i++) {

            if (!grids[i].getResultsByCategory) { continue; }
            var resultsByCategory = grids[i].getResultsByCategory();
            if (!resultsByCategory.length) { return; }

            for (var j=0; j<resultsByCategory.length; j++) {
                var rows = resultsByCategory[j]['rows'];
                for (var k=0; k<rows.length; k++) {
                    var row = rows[k];
                    if ( !(row && row.getLabTest() && row.getLabTestCategory()) ) { continue; }
                    if (!row.getDocumentingPersonnelId()) {
                        //only manually created grids should be showing up here
                        UIM && UIM.logError('Attempting to edit a grid without a documenting personnel ID. Row JSON:\n'+JSON.stringify(row));
                    }

                    // this dict has weird keys, because it's emulating the manual-entry form
                    var rowData = {
                        vendor_id: vendorId,
                        result_id: row.getId(),
                        labtestcategory_id: row.getLabTestCategory().getId(),
                        panel_name: row.getLabTestCategory().getName(),
                        labtest_id: row.getLabTest().getId(),
                        test_name: row.getLabTest().getName(),
                        value: row.getValue(),
                        ref_min: row.getReferenceMin(),
                        ref_max: row.getReferenceMax(),
                        units: row.getUnits()
                    };
                    addLabValue(rowData, false);
                }
            }
        }

        // if we have lab data (grids) ,then we populate vendorId if it's given,
        // if not, we don't force it (since the quick add doesn't give a lab vendorId)
        if (grids) {
            if (vendorId) {
                form.setVal('vendorId', vendorId);
                form.disableField('vendorId');
            }
            $(".after-vendor-selected").show();
            $(".panel-field-section").show();
            $(".after-panel-selected").show();
        }
        else {
            form.setVal('vendorId', vendorId);
            form.disableField('vendorId');
        }
    };

    module.processTestForm = function() {
        if (! (form.getVal('testName') || form.getVal('value') ||
            form.getVal('refMin') || form.getVal('refMax') || form.getVal('units')) ) {
               return; //test form is empty - nothing to process
        }
        if (!validateTestForm()) { return false; }
        var newLabValue = form.getMapped(true, true);
        newLabValue.labtestcategory_id = form.getMindreaderItem('panelName').id;
        newLabValue.labtest_id = form.getMindreaderItem('testName').id;
        var oldLabValue = labValuesDict[newLabValue.labtest_id];
        if (!oldLabValue || oldLabValue.deleted) {
            //new test or this test was already deleted from the user's perspective
            addLabValue(newLabValue, true);
        } else {
            el8.uiwidget.confirm('This test has already been added to this report. Replace the older value?',
                function() { addLabValue(newLabValue, true); },
                function() { resetTestForm(); }
            );
            return false; //stop submission because we need to wait on the confirm dialog response
        }
    };

    module.hasLabValues = function() {
        return !$.isEmptyObject(labValuesDict);
    };

    module.getQuickAddLabValues = function() {
        var that = this;

        // grabs all the fields quick add fields and get the lab values
        var $content = $('.new-lab-entry-panel');
        var $labValueFieldInputs = $('.lab-value-field-entry', $content);
        var valueArray = [];

        $labValueFieldInputs.each( function($index, $input) {
            $input = $($input);
            var val = $.trim($input.val());
            if (val == '') return;

            // lookup labtest id, then use that to lookup local cache of lab attributes
            var labtestId = $input.attr('data-labtest-id');

            if (that._labtests.hasOwnProperty(labtestId)) {
                var labtestData = that._labtests[labtestId];
                var obj = $.extend({}, labtestData);
                obj['result_id'] = null;
                obj['value'] = val;

                valueArray.push(obj);
            }
        });
        return valueArray;
    }

    /**
     * We use an object rather than an array to store labValues since delete[]
     * for arrays creates gaps but delete[] for objects doesn't. However, it's
     * more convenient for the server to get an array of labValue dicts. We also
     * want to cast 'vendor_id' to an int (it comes out of the dropdown as a string),
     * to eliminate entries that haven't been edited, and to separate deleted labs
     */
    module.labValuesForServer = function() {
        var valueArray = [];
        var deletedResults = [];
        for (var key in labValuesDict) {
            if (labValuesDict.hasOwnProperty(key)) {
                var labValue = labValuesDict[key];
                if (labValue.deleted) {
                    deletedResults.push(labValue.result_id);
                } else if (labValue.dirty) {
                    if (labValue.vendor_id) {
                        labValue.vendor_id = labValue.vendor_id*1;
                    }
                    //Keep the API clean by filtering out 'dirty', 'panel_name', and
                    //other keys the server doesn't care about
                    var serverRelevantKeys = {
                        vendor_id: labValue.vendor_id,
                        labtestcategory_id: labValue.labtestcategory_id,
                        labtest_id: labValue.labtest_id,
                        value: labValue.value,
                        ref_min: labValue.ref_min,
                        ref_max: labValue.ref_max,
                        units: labValue.units,
                        result_id: labValue.result_id
                    };
                    valueArray.push(serverRelevantKeys);
                }
            }
        }

        valueArray = valueArray.concat(this.getQuickAddLabValues());

        return {
            labValues: valueArray,
            deletedLabResults: deletedResults
        };
    };

    /**
     * Cleanup function
     */
    module.clearDialog = function() {
        labValuesDict = {};
        $('.lab-value-list', container).empty();
        $('.after-vendor-selected', container).hide();
        $('.panel-field-section', container).hide();
        $('.after-panel-selected', container).hide();
    };

    // very similar to fax inbox, stores the lab panel information into _labtests
    // and updates the html elements to show the lab value forms
    module.updatePanelLabValues = function(panels) {
        var that = this;
        var $container = $("#panel-lab-values-content");
        $container.html('');

        that._labtests = {}; // maintains a list of labs + values
        that._labtest_values = {}; // maintains a list of lab values entered

        panels.forEach(function (panel, index) {
            var a = el8.template.appshared.dialog.addDiscreteLabValues.labPanelSection({
                labtestcategoryId: panel.labtestcategory_id,
                vendorId: panel.vendor_id,
                description: panel.description,
                tests: panel.tests,
                oldCss: true
            });
            $container.append(a);

            panel.tests.forEach(function(test) {
                that._labtests[test.labtest_id] = test;
                that._labtests[test.labtest_id]['labtestcategory_id'] = panel.labtestcategory_id;
                that._labtests[test.labtest_id]['vendor_id'] = panel.vendor_id;
            });
        });

        $container.on('blur', '.lab-value-field-entry',  function(e) {
            var $input = $(e.currentTarget);
            var value = $input.val();
            var id = $input.attr('data-labtest-id');

            if (!value) {
                delete that._labtest_values[id];
            }
            else {
                that._labtest_values[id] = value;
            }
        });

        $container.on('keyup', '.lab-value-field-entry',  function(e) {
            var $input = $(e.currentTarget);
            var value = parseFloat($input.val());
            var labtestId = $input.attr('data-labtest-id');

            var isAbnormal = false;
            if (that._labtests.hasOwnProperty(labtestId)) {
                var labtestData = that._labtests[labtestId];
                var min = labtestData['ref_min'];
                var max = labtestData['ref_max'];

                if (min != null) {
                    if (value < min) {
                        isAbnormal = true;
                    }
                }
                if (max != null) {
                    if (value > max) {
                        isAbnormal = true;
                    }
                }
            }

            if (isAbnormal) {
                $input.addClass('el8AttentionText el8Bold');
            }
            else {
                $input.removeClass('el8AttentionText el8Bold');
            }
        });

        // adding tooltip for each of the lab value entry
        $container.find('.lab-value-field-entry').each( function() {

            var $this = $(this);
            var labtestId = $this.attr('data-labtest-id');

            var msg = 'Ref Range: ';
            if (that._labtests.hasOwnProperty(labtestId)) {
                var labtestData = that._labtests[labtestId];
                var min = labtestData['ref_min'];
                var max = labtestData['ref_max'];

                if (min != '' && min != null) {
                    if (max != '' && max != null) {
                        msg += min + " - " + max;
                    }
                    else {
                        msg += "> " + min;
                    }
                }
                else {
                    if (max != '' && max != null) {
                        msg += "< " + max;
                    }
                    else {
                        msg += "Not Specified";
                    }
                }
            }

            el8.service.tooltip.create({
                anchor: $this,
                text: msg
            });
        });

        panels.forEach(function (panel, index) {
            var panelSelector = "#add-panel-lab-value-" + panel.labtestcategory_id;

            var collapsible = el8.uiwidget.collapsible({
                container: $(panelSelector+'-section', $container),
                triggerElt: $(panelSelector+'-trigger', $container),
                statusElt: $(panelSelector+'-status', $container),
                expandFn: function() {},
                collapseFn: function() {}
            });

            $(panelSelector+'-trigger', $container).trigger('click');
        });
    }

    /* Helper function */

    // used by addDiscreteLabValues to initialize the form fields
    // based on whether we have existing lab values or not
    module.initSectionsWithExistingLabValues = function(vendorId) {
        $('.legacy-lab-entry-header').hide();
        $('#add-lab-values-chartdialog').hide();
        $('.new-lab-entry-panel').hide();
        $('.legacy-lab-entry-panel').show();
        $('.new-lab-entry-trigger').hide();

        if (vendorId) {
            $('.after-vendor-selected').show();
            $('.after-panel-selected').hide();
        }
        else {
            $('.after-vendor-selected').hide();
            $('.after-panel-selected').hide();
        }
        $('.lab-entry-result-section').show();
    }

    module.initSectionsWithNoExistingLabValues = function() {
        $('#add-lab-values-chartdialog').show();
        $('.new-lab-entry-panel').show();
        $('.legacy-lab-entry-panel').hide();
        $('.new-lab-entry-trigger').show();

        $('.after-vendor-selected').hide();
        $('.after-panel-selected').hide();
        $('.lab-entry-result-section').hide();
    }

    function bindListeners() {
        var that = this;
        container.on('click', '.legacy-lab-entry-trigger',  function() {
            $('#add-lab-values-chartdialog').hide();
            $('.new-lab-entry-panel').hide();
            $('.legacy-lab-entry-panel').show();
        });

        container.on('click', '.new-lab-entry-trigger',  function() {
            $('#add-lab-values-chartdialog').show();
            $('.new-lab-entry-panel').show();
            $('.legacy-lab-entry-panel').hide();
        });

        // When a new vendor is selected: let the user choose a panel or create a vendor
        container.on('change', ':input[name=vendorId]',  function() {
            var showPanel = function() {
                $('.after-vendor-selected', form.getContainer()).show();
                $('.panel-field-section', form.getContainer()).show();
                if (adjustHeightFn) { adjustHeightFn(); }
            };
            var hidePanel = function() {
                $('.after-vendor-selected', form.getContainer()).hide();
                $('.panel-field-section', form.getContainer()).hide();
                if (adjustHeightFn) { adjustHeightFn(); }
            };

            var $that = $(this);
            var $options = $that.find('option');
            var vendorId = form.getVal('vendorId');
            if (vendorId) {
                showPanel();
                if (form.getVal('panelName')) {
                    form.clearField('panelName');
                    form.clearField('testName');
                    form.getInputField('panelName').change();
                }
            } else {
                // vendorId is false when the user selects 'create a new vendor'
                el8.appshared.dialog.createLabResultVendor.show({
                    saveCb: function(data) {
                        var newVendor = el8.data.labTestVendors.create(data);
                        // The very last option in the list is 'create a new vendor'
                        // The new entry should go right before that one
                        $options.last().before(
                            el8.template.appshared.dialog.addDiscreteLabValues.vendorOption({
                                vendor: newVendor.asSoyMap()
                            })
                        );
                        $that.val(newVendor.getId());
                        showPanel();
                    },
                    hideCb: function() {
                        $options.first().prop('selected', true);
                        hidePanel();
                    }
                });
            }
        });
        // When a new panel is selected: if it's valid, let the user add tests and lock down the vendor
        container.on('change', ':input[name="panelName"]',  function() {
            if (form.getMindreaderItem('panelName')) {
                form.disableField('vendorId');
                form.setVal('testName', '');
                $('.after-panel-selected', container).show();
                $('.test-hidden-info', container).hide();
                if (adjustHeightFn) { adjustHeightFn(); }
            } else {
                var panelMr = form.getMindreader('panelName');
                //if this is a change event caused by a click on the MR, don't do anything
                if (panelMr.checkIsVisible() && panelMr.checkIsBeingClicked()) { return; }

                panelMr.hide();
                promptForPanel(form.getVal('panelName')); //promptForPanel needs to happen before resetPanelForm
                if (!module.hasLabValues()) {
                    that.resetPanelForm();
                    form.enableField('vendorId');
                }
                $('.after-panel-selected', container).hide();
                $('.test-hidden-info', container).show();
                if (adjustHeightFn) { adjustHeightFn(); }
            }
        });
        // When a new test is selected: if it's invalid, auto-bring up the dialog to add a new test
        container.on('change', ':input[name="testName"]',  function() {
            var testMr = form.getMindreader('testName');
            //if this is a change event caused by a click on the MR, don't do anything
            if (testMr.checkIsVisible() && testMr.checkIsBeingClicked()) { return; }

            if (!form.getMindreaderItem('testName')) {
                testMr.hide();
                promptForTest(form.getVal('testName'));
            }
        });
        // User wants to add a lab result to the list
        container.on('click', '.add-lab-value-trigger',  function() {
            module.processTestForm();
        });
        // User wants to clear the whole form
        container.on('click', '.clear-lab-form-trigger',  function() {
            that.resetPanelForm();
            form.getInputField('panelName').change(); //trigger div hide events, etc.
        });
        // User wants to edit a lab result already in the list
        container.on('click', '.edit-lab-value-trigger',  function() {
            var $entry = $(this);
            var $row = $entry.closest('.lab-value-row');
            var labValue = labValuesDict[$row.attr('_id')];

            //don't use form.populate b/c we don't want to set panel and vendor
            //and because our dict has under_scored keys, unlike the form fieldNames
            form.setMindreaderItem('panelName', {
                id: labValue.labtestcategory_id,
                name: labValue.panel_name
            });
            form.setMindreaderItem('testName', {
                id: labValue.labtest_id,
                name: labValue.test_name,
                isManual: true //to avoid querying for ref range and units
            });
            form.setVal('value', labValue.value);
            form.setVal('refMin', labValue.ref_min);
            form.setVal('refMax', labValue.ref_max);
            form.setVal('units', labValue.units);
            form.focusField('testName');
        });
        // User wants to remove a lab result form the list
        container.on('click', '.remove-lab-value-trigger',  function() {
            removeLabValue($(this));
        });
    }

    function promptForPanel(val) {
        if (!val) { return; }
        el8.uiwidget.confirm('Are you sure you want to create a new panel called "' + val + '"? ' +
            'If not, select a panel from the dropdown.',
            function() {
                var panel = {
                    description: val,
                    vendor_id: form.getVal('vendorId')
                };
                $.el8_ajax({
                    url: el8.service.urls.get('labTestPanels'),
                    type: 'POST',
                    data: {'data': JSON.stringify(panel)},
                    success: function(data) {
                        el8.appservice.notifier.notify('New panel created.');
                        form.setMindreaderItem('panelName', {
                            name: data.name,
                            id: data.id
                        });
                        form.focusField('testName');
                    }
                });
             },
             function() {
                form.setVal('panelName', '');
             }
        );
    }

    function promptForTest(val) {
        if (!val) { return; }
        el8.appchart.dialog.createLabResultTest.show({
            defaultLabName: val,
            vendor: {
                id: form.getVal('vendorId'),
                name: form.getInputField('vendorId').find(':selected').text()
            },
            panel: {
                id: form.getMindreaderItem('panelName').id,
                name: form.getMindreaderItem('panelName').name
            },
            saveCb: function(item) {
                form.setMindreaderItem('testName', item);
                form.focusField('value');
            }
        });
    }

    function validateTestForm() {
        if (!form.getMindreaderItem('testName')) {
            el8.uiwidget.alert('Please select an existing test name from the autocomplete or create a new test to add this lab result.',
                form.getInputField('testName'));
            return false;
        }
        if (!form.getVal('value')) {
            el8.uiwidget.alert('Please add a lab value to add this lab result or clear the form to ignore it.',
                form.getInputField('value'));
            return false;
        }
        return true;
    }

    // Reset everything except Vendor and Panel (i.e., from Test down)
    function resetTestForm() {
        var chosenVendor = form.getVal('vendorId');
        var chosenPanel = form.getMindreaderItem('panelName');
        if (!chosenVendor || !chosenPanel) { return; } //auto-entry, not form entry
        form.reset();

        //emulate not resetting the vendor and panel fields
        form.setVal('vendorId', chosenVendor);
        form.setMindreaderItem('panelName', chosenPanel);
        form.focusField('testName');
    }

    // Reset everything except Vendor (i.e., from Panel down)
    module.resetPanelForm = function() {
        var chosenVendor = form.getVal('vendorId');
        form.reset();
        form.setVal('vendorId', chosenVendor);
    }

    function addLabValue(newLabValue, isUserEntered) {
        //pre-pend zero to strings beginning with a dot
        var preProcessNumbers = function(str) {
            if (!str) { return; }
            str = str.trim();
            if (str && str[0] === '.' && !isNaN(parseFloat(str, 10))) {
                str = '0'+str;
            }
            return str;
        };
        newLabValue.value = preProcessNumbers(newLabValue.value); //should always exist
        if (newLabValue.ref_min !== undefined) {
            newLabValue.ref_min = preProcessNumbers(newLabValue.ref_min);
        }
        if (newLabValue.ref_max !== undefined) {
            newLabValue.ref_max = preProcessNumbers(newLabValue.ref_max);
        }

        var oldLabValue = labValuesDict[newLabValue.labtest_id];
        var $labValue = $(el8.template.appshared.dialog.addDiscreteLabValues.labEntry(newLabValue));
        if (oldLabValue) {
            $('.lab-value-row[_id="' + newLabValue.labtest_id + '"]', container).replaceWith($labValue);
             newLabValue.result_id = oldLabValue.result_id;
        } else {
            var $labList = $('.lab-value-list', container);
            if (!$labList) { return; }
            var $panel = $labList.find('.lab-panel[_id="' + newLabValue.labtestcategory_id + '"]');
            if (!$panel.length) {
                $panel = $(el8.template.appshared.dialog.addDiscreteLabValues.labPanel(newLabValue));
                $labList.append($panel);
            }
            $panel.append($labValue);
        }

        if (isUserEntered) {
            $labValue.addClass('itemAdded');
            $.el8_setTimeout(function() { $labValue.removeClass('itemAdded'); }, 10000);
        }
        newLabValue.dirty = isUserEntered; //whether to include this in the list of changed/new results for the server
        labValuesDict[newLabValue.labtest_id] = newLabValue;
        resetTestForm();
        if (adjustHeightFn) { adjustHeightFn(); }

        $('.lab-entry-result-section').show();
    }

    function removeLabValue($entry) {
        var $row = $entry.closest('.lab-value-row');
        var $panel = $entry.closest('.lab-panel');
        var rowId = $row.attr('_id');
        if (labValuesDict[rowId].result_id) {
            //if these entries have already been saved, keep a stub around to tell the server to delete
            labValuesDict[rowId] = {
                deleted: true,
                dirty: true,
                result_id: labValuesDict[rowId].result_id
            };
        } else {
            //otherwise just delete
            delete labValuesDict[rowId];
        }
        $row.remove();
        if (!$panel.find('.lab-value-row').length) { $panel.remove(); }
        if (adjustHeightFn) { adjustHeightFn(); }
    }

    return module;

})();
